import React, {useEffect} from "react";
import {ShowableProductCard} from "ReactApp/Ddd/Aggregates/ShowableProductCard";
import IconV1 from "ReactApp/Components/IconV1/IconV1";

type AddToWishListV1Props = {
    productCard: ShowableProductCard
}

const AddToWishListV1 = ({ productCard }: AddToWishListV1Props) => {

    const { currentProductConfig } = productCard;

    if (!currentProductConfig) {
        return <div>Загрузка...</div>;
    }

    const uniqueKey = currentProductConfig.getUniqueId();

    useEffect(() => {
        window?.widgets?.addToWishListV1?.checkSelected();
    }, [uniqueKey]);

    return (
        <div className="icon-button heart add-to-wishlist-v1" key={uniqueKey}
            add-to-wishlist-v1=""
            data-add-to-wishlist-v1-is-in-wishlist="0"
            data-add-to-wishlist-v1-product-type-id={currentProductConfig.productTypeId}
            data-add-to-wishlist-v1-id={currentProductConfig.id}
            data-add-to-wishlist-v1-virtual-modifier-id={currentProductConfig.virtualModifierId ?? ""}>
            <IconV1 {...{
                svgSpriteId: 'heart-icon-v2',
                width: 20,
                height: 20,
                classes: [
                ]
            }} />
        </div>
    );
}

export { AddToWishListV1 };